import CommentInputBox from "../../../../components/CommentBox/CommentInputBox";
import Comment from "../../../../components/CommentBox/Comment";
import {useCommunity} from "../../../../redux/Reducers/CommunityComments";
import {useEffect, useState} from "react";
import Filter from "../../../../components/Filter/Filter";
import {CommentFilterData, CommentLoadingAnimation} from "../../Community/components/UserComments";
import useCommentSection from "../../../../hooks/useCommentSection";
import {LiaBatteryEmptySolid} from "react-icons/lia";
import {useLocation, useParams} from "react-router-dom";

export default function CommentSection({className, show,id, ...props}) {

    const [state, isLoading, actions] = useCommentSection(id);
    useEffect(() => {
        actions.initalLoad();
    }, [])

    return (
        <div className={`${show ? "flex" : "hidden"} mt-2 w-full flex flex-col gap-2 ${className}`}>
            <CommentInputBox className={"w-full"} onAddComment={actions.addNewComment}/>
            <div className={`mb-4 border-b-[1px] pb-4   mt-2 `}>
                <div className={"flex flex-row gap-2"}>
                    <p className={"font-semibold flex-1"}>
                        {state?.count} Comments
                    </p>

                    <div className={"flex gap-2"}>
                        <Filter {...CommentFilterData} defaultValue={state?.sortBy} onChange={(sortBy) => {
                            actions.SortBy(sortBy);
                        }}/>
                    </div>
                </div>
            </div>
            {
                !isLoading && state?.comments?.length === 0 &&
                <div className={"flex flex-col my-12 gap-2 items-center"}>
                    <LiaBatteryEmptySolid className={"text-4xl"}/>

                    <p className={"font-bold text-xl text-center"}>
                        No comments yet
                    </p>
                    <p className={"text-center"}>
                        Be the first to comment
                    </p>
                </div>
            }
            {
                state?.newComments?.map((comment, i) => (
                    <Comment comment={comment} key={comment?.id}
                             deleteComment={() => actions.deleteComment(comment?.id)}/>
                ))
            }
            {
                state?.comments?.map((comment, i) => (
                    <Comment comment={comment} key={comment?.id}
                             deleteComment={() => actions.deleteComment(comment?.id)}/>
                ))
            }
            {
                isLoading && <CommentLoadingAnimation/>
            }


            {state?.next && <div onClick={actions.loadMoreComments}
                                 className={"flex-1 gap-3 cursor-pointer mb-4 lg:mb-8 flex justify-center items-center"}>
                <p className={"bg-tertiary-150 h-10 w-10 rounded-full text-center text-2xl text-tertiary-900"}>
                    +
                </p>
                <p className={"text-lg font-bold "}>
                    Load More
                </p>
            </div>}

        </div>

    )
}
